/* eslint-disable react-hooks/exhaustive-deps */
import { useAnalyticsService } from '@completeanatomy/analytics';
import { useBridge } from '@completeanatomy/bridge';
import { getAppState } from '@completeanatomy/common';
import React, { useEffect } from 'react';
import { RouterProvider } from 'react-router-dom';
import './fonts.css';

import { useConfigSetup } from './hooks/useConfigSetup';
import { router } from './router';
import { clearRevokedCookies } from './utils/cookies/clearRevokedCookies';
import { getOneTrustActiveGroupsIds } from './utils/cookies/getOneTrustActiveGroupsIds';

function App() {
  useConfigSetup();

  const analyticsService = useAnalyticsService();
  const bridge = useBridge();

  useEffect(() => {
    const onOneTrustGroupsUpdated = async () => {
      const activeGroups = getOneTrustActiveGroupsIds();
      const analyticsCookieAccepted = activeGroups.includes('2');

      if (analyticsCookieAccepted) {
        await analyticsService.initialize();
      } else {
        analyticsService.teardown();
      }

      clearRevokedCookies();
    };

    onOneTrustGroupsUpdated();

    window.addEventListener('OneTrustGroupsUpdated', onOneTrustGroupsUpdated);

    return () => {
      window.removeEventListener(
        'OneTrustGroupsUpdated',
        onOneTrustGroupsUpdated
      );
    };
  }, []);

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const immediateSignup = urlParams.get('immediate_signup');

    if (immediateSignup === 'true' && bridge) {
      bridge.signUp();

      urlParams.delete('immediate_signup');
      const newUrl =
        window.location.pathname +
        (urlParams.toString() ? '?' + urlParams.toString() : '');

      window.history.replaceState({}, '', newUrl);
    }
  }, [bridge]);

  return <RouterProvider router={router} />;
}

//@ts-ignore
window.getAppState = () => {
  console.log(getAppState());
};

export default App;
